import { env } from 'app/env'
import { pipe } from 'fp-ts/function'
import { decodeJson, del, post } from 'lib/request'

import { TAuthResponse } from './token.codecs'

export const refreshToken = async () => {
  return pipe(
    await post('api/auth/tokens/refresh', {
      body: {
        client: env.REACT_APP_CLIENT_ID,
      },
    }),
    decodeJson(TAuthResponse),
  )
}

export const login = async ({
  email,
  password,
}: {
  email: string
  password: string
}) => {
  return pipe(
    await post('api/auth/tokens/credentials', {
      body: {
        client: env.REACT_APP_CLIENT_ID,
        email,
        password,
      },
    }),
    decodeJson(TAuthResponse),
  )
}

export const logout = async () => {
  return await del('api/auth/tokens/me', {})
}
